// @flow

import Loadable from "react-loadable";
import DynamicImportLoader from "app/components/atoms/DynamicImportLoader/DynamicImportLoader";
import type { InteractivesMenuItemConfig } from "../interactives-list";
import DisplayImage from "./image.png";

const description =
  "A footer module with an 'About the data' section and optional 'Credits'.";
const CONFIG: InteractivesMenuItemConfig = {
  name: "About the data",
  id: "about-the-data",
  groupsWithAccess: ["specialist_user", "editor_user"],
  linkPrefix: "/interactives",
  tags: ["Configurable"],
  description,
  image: DisplayImage,
  cradleIframeUrlRoot:
    "https://www.smh.com.au/interactive/modules/about-the-data/?resizable=true",
  ConfigComponent: Loadable({
    delay: 200, // See 'Avoiding Flash Of Loading Component': https://github.com/jamiebuilds/react-loadable
    loader: () =>
      import(/* webpackChunkName: "AboutTheDataConfigTool" */ "app/components/tools/AboutTheDataConfigTool/AboutTheDataConfigTool"),
    loading: DynamicImportLoader,
    modules: ["AboutTheDataConfigTool"]
  })
};

export default CONFIG;
